"use strict";

module.exports = function () {
	try {
		Object.keys("primitive");
		return true;
	} catch (e) {
		return false;
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/object/keys/is-implemented.js
// module id = 11
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/es5-ext/object/keys/is-implemented.js